import { BaseGridDropListComponent } from '@anecdotes/design-system/drag-drop';
import { LoaderManagerService } from '@anecdotes/design-system/loaders';
import { OrderResourceType, RequirementsCategoryResponse, TrustCenterFacadeService } from '@anecdotes/shared-trust-center';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  OnDestroy,
  OnInit,
  SkipSelf
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable, combineLatest } from 'rxjs';

@Component({
  selector: 'app-controls',
  templateUrl: './controls.component.html',
  styleUrls: ['./controls.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ControlsComponent extends BaseGridDropListComponent implements OnInit, OnDestroy {
  categories: RequirementsCategoryResponse[];
  editing$: Observable<boolean>;

  constructor(
    @SkipSelf() private loaderManager: LoaderManagerService,
    private trustCenterFacadeService: TrustCenterFacadeService,
    private destroyRef: DestroyRef,
  ) {
    super();
  }

  ngOnInit(): void {
    this.editing$ = this.trustCenterFacadeService.isEditing();

    combineLatest([this.trustCenterFacadeService.getCategories(), this.editing$])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(([categories, editing]) => {
        const visible = categories.filter((category) => this.isCategoryVisible(category));
        const invisible = categories.filter((category) => !this.isCategoryVisible(category));

        if (editing) {
          this.categories = [...visible, ...invisible];
        } else {
          this.categories = visible;
        }

        this.cd.detectChanges();
      });
  }

  ngOnDestroy(): void {
    this.loaderManager.hide();
  }

  buildTranslationKey(key: string): string {
    return `trustCenter.${key}`;
  }

  isCategoryDraggable(category: RequirementsCategoryResponse): boolean {
    return category.requirements.filter((requirement) => requirement.is_visible)?.length > 0;
  }

  updateOrder(sourceIndex: number, targetIndex: number): void {
    moveItemInArray(this.categories, sourceIndex, targetIndex);

    const orderList = this.categories.map((category) => category.name);
    this.trustCenterFacadeService.reorderResources(OrderResourceType.RequirementCategory, orderList);
  }

  private isCategoryVisible(category: RequirementsCategoryResponse): boolean {
    return !!category.requirements.filter((requirement) => requirement.is_visible).length;
  }
}
